// source: https://github.com/apexcharts/apexcharts.js/blob/main/src/modules/Formatters.js

import ApexDateTime from 'services/apex-chart-services/utils/apex-date-time';

/**
 * ApexCharts Formatter Class for setting value formatters for axes as well as tooltips.
 *
 * @module Formatters
 **/

class ApexFormatters {
  constructor(ctx) {
    this.ctx = ctx;
    this.w = ctx.w;
    this.tooltipKeyFormat = 'dd MMM';
  }

  xLabelFormat(fn, val, timestamp, opts) {
    const w = this.w;

    // if user has not specified a custom formatter, use the default tooltip.x.format
    if (
      w.config.xaxis.type === 'datetime' &&
      w.config.xaxis.labels.formatter === undefined &&
      w.config.tooltip.x.formatter === undefined
    ) {
      const datetimeObj = new ApexDateTime(this.ctx);
      return datetimeObj.formatDate(datetimeObj.getDate(val), w.config.tooltip.x.format);
    }

    return fn(val, timestamp, opts);
  }
}

export default ApexFormatters;
